import Decimal from "decimal.js";
export const amountWithPrecision = (val, precision) => {
    return new Decimal(val).toFixed(precision).replace(/\.?0+$/, '');
};
